import { Link, useLocation } from "react-router-dom"


export default function BreadCrumbsAppo() {

    const {pathname} = useLocation();
    const arrLink = pathname.split("/")

    const translation: any = {
        appointments: "Gestione globale appuntamenti",
    }

    return(
        <div className="space-x-2 text-[14px]">
            <Link className="text-gray-400" to={'/dashboard/home'}>
                Dashboard
            </Link>
            <span>-</span>
            <Link className={`${arrLink.length == 3 ? 'text-black font-bold' : 'text-gray-400'}`} to={`/${arrLink[1]}/${arrLink[2]}`} >
                {translation[arrLink[2]]}
            </Link> 
            {arrLink.length == 5 && <span>-</span>}
            <span className={`${arrLink.length == 5 && 'text-black font-bold'}`}>{translation[arrLink[3]]}</span>
        </div>
    )
}